import React from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { Collapse } from 'bootstrap';
import { Modal } from 'bootstrap';
import TapSelect from '../../../components/ui/TapSelect';
import AppBaseComponent from '../../../components/AppBaseComponent';
import HttpAPICall from '../../../services/HttpAPICall';
import { IAM_API_BASE_URL_2 } from '../../../services/TapApiUrls';
import Ax from "../../../components/hoc/Ax";
import Loader from "../../../components/ui/Loader/Loader";
import ApplicationLayout from '../../../layouts/ApplicationLayout';
import TapIcon from '../../../services/TapIcon';
import AssetDetailHorizontalCard from '../includes/AssetDetailHorizontalCard';
import { DisplayListPagination, DisplaySearchCriteria, PeriodSelectionWithCustom } from '../../../components/TapUi';
import AssetHeader from '../includes/AssetHeader';
import { Helmet } from 'react-helmet';
import AssetActivityView from '../../transactions/assetActivity/AssetActivityView';
import swal from 'sweetalert';
import download from '../../../services/DownloadFile';
import moment from 'moment';

class AssetActivity extends AppBaseComponent {
    
    constructor(props) {
        super(props);
    
        this.activitySearchInitState         =   {
            'search_transaction_id'         :   '',
            'search_activities'             :    [],
            'site_group_ids'                :    [],
            'search_activity_type'          :   '',
            'search_site_ids'               :   [],
            'date_range'                    :   '',
            'date_range_start'              :   null,
            'date_range_end'                :   null,
            'entry_date_range'              :   '',
            'entry_date_range_start'        :   null,
            'entry_date_range_end'          :   null,
           'activity_transaction_delay'     :   ''
        };

        this.activitySearchFormLabel         =   {
            'site_group_ids'            :      'Site Groups : ',
            'search_activities'            :   'Activity : ',
            'search_activity_type'           :   'Activity Type : ',
            'search_site_ids'                :   'Site : ',
            'search_transaction_id'          :   'Transaction ID : ',
            'date_range'                     :   'Transaction Period : ',
            'entry_date_range'               :   'Date of Entry : ' ,
            'activity_transaction_delay'     :   'Transaction Delay : '
        };

        this.state                          =       {
            access_token                    :       '',
            assetDetail                     :       null,
            listing_loading                 :       false,
            listing_tbl_page                :       1,
            activityListing                 :       [],
            listingMeta                     :       null,
            totalListingCount               :       0,
            asset_loading                   :       false,
            assetId                         :       null,
            current_page                    :       1,
            minimizeTable                   :       false,
            view_loading                    :       false,
            iam_group_sites             :          [],
            all_periods                 :          [],
            activitySearchForm          :          {...this.activitySearchInitState},
            formSearchedElems           :          [],
            activitySearchParams        :          null,
            file_downloading            :          false,
            allTransactionDelay         :          [],
            searchedEmployees           :           [],
            allActivitesList            :           [],
            allActivityTypeList         :           [],
            allSiteGroupsList           :           [],
        }
       
    }
    
    componentDidMount           =   ()  =>  {
        this.initalizeData(this.props)
        this.searchFormDataInit(this.props);
        this.activitySearchModal         =    new Modal(document.getElementById('activitySearchModal'), {keyboard: false, backdrop :false});

    }
    
    componentWillReceiveProps(nextProps) {
        if(this.props.match.params.id !== nextProps.match.params.id){
            this.initalizeData(nextProps)
        }
    }

    
    initalizeData       =       (pr)        =>      {
        this.setState({assetId              :       pr.match?.params?.id,
            },() => {
                    
            this.getAsssetDetails(pr.match?.params?.id)
            this.getAssetActivityListing(1,pr.match?.params?.id)
            this.searchFormDataInit(pr)
        })
    }
    

    getAsssetDetails                =   (id)  =>  {
        let Id  = id ? id  : this.state.assetId
        this.setState({asset_loading : true});
        HttpAPICall.withAthorization('GET', IAM_API_BASE_URL_2 + '/asset/' + Id, this.props.access_token , {}, {}, (response) => {
            this.setState({assetDetail : response.data.data});
        }, (error) => {
            toast.error(error?.msg, { position: toast.POSITION.TOP_RIGHT });
        }).then(() => {this.setState({asset_loading: false})})
    }

    getAssetActivityListing(page,id){
        this.setState({listing_loading: true, listing_tbl_page: page});
        let params                      =   {page:page,need_asset_profile : 'N',need_counterlog : 'Y',search_asset_id : id ? id : this.state.assetId};
        HttpAPICall.withAthorization('GET', IAM_API_BASE_URL_2 + '/counterlog/activity_list', this.state.access_token ? this.state.access_token : this.props.access_token, params, {}, (resp) => {
            let respData = resp.data;
            this.setState({
                activityListing           :           respData.data,
                listingMeta                :          {
                    from                        :   respData.meta.from,
                    to                          :   respData.meta.to,
                    total                       :   respData.meta.total,
                    last_page                   :   respData.meta.last_page,
                    per_page                    :   respData.meta.per_page,
                    current_page                :   respData.meta.current_page
                },
                totalListingCount          :           respData.meta.total,
        });
        }).then(() => this.setState({listing_loading: false}));
    }

    getActivityData(id){
        this.setState({ view_loading: true })
        let params = {need_asset_full_profile : 'N',need_counterlog : 'Y',need_site : 'Y'}
        HttpAPICall.withAthorization('GET', IAM_API_BASE_URL_2 + '/counterlog/activity/' + id, this.props.access_token, { ...params }, {}, (response) => {
            this.setState({
                activityData: response.data.data
            })
        }, (error) => {
            toast.error(error?.msg, { position: toast.POSITION.TOP_RIGHT });
        }).then(() => this.setState({ view_loading: false }))
        
    }

    viewActivity(id){
        this.setState({minimizeTable:true})
        this.getActivityData(id)
    }

    
    assetCardHandler                     =   (collapse = true)  =>  {
        new Collapse(document.getElementById('assetCard'));
        if(document.getElementById('pageTbl')) {
            document.getElementById('pageTbl').scroll({ top: 0, behavior: 'smooth' });
        }
    }



    closeAssetActivityView                    =      ()              =>         {
        this.setState({minimizeTable:false})
    }

    activityDownloadHandler                 =   ()  =>  {
        let params                          =   {...this.state.activitySearchParams};
        if(this.state.activitySearchParams !== null){
            this.activityDownloadStart(params);
        } else {
            swal({ title: "Download",
            text: "The download will be for Current Month's Transaction, in case you want different Transaction Period then please change by filter.",
            icon: "warning",
            buttons: ["Cancel", "Okay"],
            }).then(willDownload => {
                if (willDownload) {
                    params = {...params , date_range: "current_month"}
                    this.activityDownloadStart(params);
                }
            });
        }
    }
    

    activityDownloadStart              =    (params)     =>         {
        this.setState({ file_downloading: true});
        HttpAPICall.withAthorization('GET', IAM_API_BASE_URL_2 + '/counterlog/activity_list', this.props.access_token,{download : "download",...params},{},(response) => {
            download.file(response.data.file_path);
        })
        .then(() => this.setState({file_downloading: false}));
    } 

    viewActivity(id){
        this.setState({minimizeTable:true})
        this.getActivityData(id)
    }

    searchFormDataInit                =   (props)  =>  {
        
        let all_periods             =              [...props.all_periods, { key: 'custom', display: 'Custom Date Range' }];
        HttpAPICall.withAthorization('GET', IAM_API_BASE_URL_2 + '/counterlog/activity_list_form-data', this.props.access_token, {})
            .then((response) => {
                let respData = response.data;
                this.setState({
                    iam_group_sites         :       props.iam_group_sites ? props.iam_group_sites.map((s) => { return { value: s.id, label: `${s.site_name} (${s.site_code})` } }) : [],
                    all_periods             :       all_periods,
                    allTransactionDelay     :       response.data && response.data.transactional_delay ? response.data.transactional_delay.map((td) => { return {value: td.key, label: td.text}}) : [],
                    allActivitesList        :       respData && respData.activities ? respData.activities.map((td) => { return {value: td.id, label: td.activity_name}}) : [],
                    allActivityTypeList     :       respData && respData.activity_type ? respData.activity_type.map((td) => { return {value: td.key, label: td.name}}) : [],
                    allSiteGroupsList       :       respData && respData.site_groups && respData.site_groups.length > 0 ? respData.site_groups.map(oc => { return ({ value: oc.id, label: oc.name, linked_sites: oc.site_ids }) }) : [],
               
                })    
            }) 
    }

    activitySearchModalInit        =       ()      =>      {
        this.activitySearchModal.show()
    }

    activitySearchClear                     =   ()  =>  {
        this.setState({
            formSearchedElems       :   [],
            activitySearchParams    :   null,
            searchedEmployees       :      [],
            activitySearchForm      :   {...this.activitySearchInitState}
        }, () => {
            this.activitySearchModal.hide();
            this.getAssetActivityListing(1)
        });
    }

    activitySearchFormSubmit               =   (event= null)  =>  {
        event && event.preventDefault();
        //Get All Keys :-
        let serachFormKeys              =   Object.keys(this.state.activitySearchForm);
        let searchedElems               =   [];
        let activitySearchParams           =   {};
        serachFormKeys.map((key)        =>  {
            let label                       =   this.activitySearchFormLabel[key];
            let value                       =   this.state.activitySearchForm[key];
            if(value && value !== "Invalid date" && value.length > 0) {
                activitySearchParams[key]      =   value;
                if(label) {
                    let show_val            =   value;
                
                    if(key == 'site_group_ids') {
                        show_val            =   this.state.allSiteGroupsList.filter((s) => value.includes(s.value)).map(s => s.label).join(', ')
                    }
                    if(key == 'search_site_ids') {
                        show_val            =   this.state.iam_group_sites.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                    }
                    if(key == 'search_activities') {
                        show_val            =  this.state.allActivitesList.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                    }
                    if(key == 'search_activity_type') {
                        show_val            =  this.state.allActivityTypeList.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                    }
                   
                    if(key == 'search_transaction_id') {
                        show_val            =  this.state.activitySearchForm && this.state.activitySearchForm.search_transaction_id ? this.state.activitySearchForm.search_transaction_id : '';
                    }
                    if(key == 'activity_transaction_delay') {
                        show_val            =   this.state.allTransactionDelay.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                    }
                    if(key == 'date_range') {
                       let  start_range          =       moment(this.state.activitySearchForm.date_range_start).format('DD-MMM-YYYY');
                       let  end_range            =       moment(this.state.activitySearchForm.date_range_end).format('DD-MMM-YYYY')
                       let  display_custom       =       `Custom Date Range (${start_range} - ${end_range})`
                       show_val                  =       this.state.all_periods.filter((s) => value.includes(s.key)).map(s => s.display_with_date ? s.display_with_date : display_custom);
                    }
                    if(key == 'entry_date_range') {
                        let  start_range          =      moment(this.state.activitySearchForm.entry_date_range_start).format('DD-MMM-YYYY');
                        let  end_range            =     moment(this.state.activitySearchForm.entry_date_range_end).format('DD-MMM-YYYY')
                        let  display_custom       =     `Custom Date Range (${start_range} - ${end_range})`
                        show_val                  =     this.state.all_periods.filter((s) => value.includes(s.key)).map(s => s.display_with_date ? s.display_with_date : display_custom);
                     }
                    
                    searchedElems.push(label + `<b>${show_val}</b>`);
                }
            }
        });
        //Generate Html :-
        this.setState({
            formSearchedElems           :       searchedElems,
            activitySearchParams      :       activitySearchParams
        }, () => {
            this.activitySearchModal.hide();
            this.getAssetActivityListing(1)
        });
    }

   
    pageTitleBarJsx          =   ()  =>  {
        let obj = {'search_asset_id' : this.state?.assetDetail?.asset_id, 'asset_name' : `${this.state?.assetDetail?.name} (${this.state?.assetDetail?.asset_code})`};
        return (<div className="page_title row m0">
            <div className="col-12 asset_collapse">
                <h3>{this.state?.assetDetail?.name}</h3>
                <AssetHeader  assetDetail={this.state.assetDetail} afterChangeStatus={this.getAsssetDetails} parentProps={this.props} />
            </div>
        </div>);
    }

    horizontalAssetCardJsx      =       ()      =>  {
        
        return (<div> 
            <div id="assetCard" className="collapse pr-1 mt-1"  aria-expanded="true" >
            {this.state.asset_loading ? <div className='text-center pt-1'><Loader/></div>
            : <AssetDetailHorizontalCard assetDetail={this.state.assetDetail} />}
        </div>
        </div>)
    }

    assetActivityListJsx            =       ()      =>    {

        return (<Ax>
            <div style={{ paddingTop: "4px" }}>
                <div className="page_title row m0" style={{ height: "45px" }}>
                    <div className={this.state.minimizeTable ? "col-sm-3" : "col-sm-6"}>
                        <h3 style={{ paddingTop: "13px" }}>Asset Activity List</h3>
                    </div>
                    {!this.state.minimizeTable
                        ? <div className='col-sm-2 '>
                            <button type="button" className="btn btn-primary btn-sm" role="button" onClick={this.assetCardHandler}> Asset Card</button>
                        </div> : null}
                    {!this.state.minimizeTable
                        ? <div className='col-sm-4 text-end mt7 '>
                           <button type="button"  disabled={this.state.listing_loading} onClick={this.activitySearchModalInit} className="btn btn-secondary" >
                        <TapIcon.imageIcon icon={TapIcon.SearchIcon} className="img-fluid" alt="item-action" />
                    </button>
                    <button type="button" className="btn btn-secondary"
                        disabled={this.state.file_downloading || this.state.listing_loading}
                        onClick={this.activityDownloadHandler} >
                        <TapIcon.FontAwesomeIcon icon={TapIcon.faDownload} />
                        {this.state.file_downloading ? (<TapIcon.FontAwesomeIcon icon={TapIcon.faSyncAlt} className="fa-spin" />) : ''}
                    </button>
                        </div> : null}
                    {
                        this.state.minimizeTable
                            ? (
                                <Ax>
                                    <div className="col-sm-3 tap_border_left">
                                        <h3 style={{ paddingTop: "13px" }}>Activity :  {this.state?.activityData?.activity_name.slice(0, 25)}{this.state?.activityData?.activity_name.length > 25 ? '...' : ''}</h3>
                                    </div>
                                    <div className='col-sm-2 '>
                                        <button type="button" className="btn btn-primary btn-sm" role="button" onClick={this.assetCardHandler}>Asset Card</button>
                                    </div>
                                    <div className='col-sm-4 text-end mt7'>
                                        
                                        <button onClick={this.closeAssetActivityView} type="button" className="btn btn-secondary">
                                            <TapIcon.imageIcon icon={TapIcon.CloseIcon} className="img-fluid" alt="item-close" />
                                        </button>
                                    </div>
                                </Ax>
                            )
                            : null
                    }
                </div>
            </div>
            <div className="container-fluid pl0 pr13">
                <div className="page_containt row">
                    <div className={['pl16', this.state.minimizeTable ? 'col-3 mr0 pr0 wd26' : 'col-12 pr0'].join(' ')}>{this.assetActivityTableJsx()}</div>
                    {this.state.minimizeTable ? <div className="col-9 pr4 wd74 pl0 pageTbl pb-5"><div className=" bg-white p-2" >{this.state.view_loading ? <Loader /> : this.assetActivityViewDetailJsx()}</div> </div> : null}
                </div>
            </div>
        </Ax>);
    }

    assetActivityTableJsx                   =   ()  =>  {
        return (
            <Ax>
                 <DisplaySearchCriteria searchedElems={this.state.formSearchedElems} onClearFilter={this.activitySearchClear} />
                <div className='table-responsive' style={{ maxHeight: this.state.formSearchedElems && this.state.formSearchedElems.length > 0 ? "59vh" : "69vh" }}>
                    <table className="table table-bordered bg-white align-items-center  table-sm table-hover table-fixed mb-0">
                        <thead className="table-secondary">
                            {this.state.minimizeTable
                                ? (<tr>
                                    <th scope="col" style={{ width: "20%" }}>Activity</th>
                                </tr>)
                                : (<tr>
                                    <th scope="col" style={{ width: "5%" }} className="text-center">S.No</th>
                                    <th scope="col" style={{ width: "10%" }} className='text-center'>Transaction Date</th>
                                    <th scope="col" style={{ width: "13%" }}>Activity Name</th>
                                    {/* <th scope="col" style={{ width: "16%" }}>Asset Name </th>
                                    <th scope="col" style={{ width: "16%" }}>Asset Type </th> */}
                                    <th scope="col" style={{ width: "12%" }}>No. of Trips/Sessions</th>
                                    <th scope="col" style={{ width: "13%" }}>Workstation (From-To)</th>
                                    <th scope="col" style={{ width: "10%" }}>Counterlog Reading</th>
                                    <th scope="col" style={{ width: "5%" }}>Action</th>
                                </tr>)
                            }

                        </thead>
                        <tbody>
                            {this.state.listing_loading
                                ? (<tr><td colSpan="10"><Loader /></td></tr>)
                                : (this.state.activityListing && this.state.activityListing.length > 0
                                    ? (this.state.activityListing.map((item, index) => {
                                        return (<tr key={index} >
                                            {
                                                this.state.minimizeTable
                                                    ? (
                                                        <Ax>
                                                            <td style={{ width: "25%" }} onClick={() => this.viewActivity(item.asset_activity_id)} >
                                                                <div className="text-capitalize link-primary cursor_pointer">{item.activity_name ? item.activity_name : '-'}</div>
                                                                <div className="mt-1">
                                                                    <small className="text-capitalize ">{item.activity_count ? <span>{item.activity_count} ({item.activity_type_name})</span> : '-'} </small>
                                                                    <small className="float-end">{item.counterlog && item.counterlog.feed_date_display ? item.counterlog.feed_date_display : "-"}</small>
                                                                </div>
                                                            </td>
                                                        </Ax>
                                                    )
                                                    : (<Ax>
                                                        <td className="text-center">{this.state.listingMeta ? this.state.listingMeta.from + index : index}</td>
                                                        <td className='text-center'>{item.counterlog && item.counterlog.feed_date_display ? item.counterlog.feed_date_display : "-"}</td>
                                                        <td className="text-capitalize link-primary cursor_pointer" onClick={() => this.viewActivity(item.asset_activity_id)} >{item.activity_name ? item.activity_name : "-"}</td>
                                                        {/* <td>{item.asset && item.asset.name ? item.asset.name : "-"}</td>
                                                        <td>{item.asset && item.asset.asset_type_name ? item.asset.asset_type_name : "-"}</td> */}
                                                        <td>{item.activity_count ? <span>{item.activity_count} ({item.activity_type_name})</span> : '-'}</td>
                                                        <td>{item.workstation_from_name} - {item.workstation_to_name}</td>
                                                        <td>{item.counterlog && item.counterlog.display
                                                            ? <span className="text-start">{item.counterlog.display.filter(s => s.label !== "Date" ? true : false).map((item, index) => {
                                                                return (<div className="mt-1">{item.label + ': ' + item.reading}</div>)
                                                            })}</span>
                                                            : "No Record"}</td>
                                                        <td className="text-center">
                                                            <button type="button" id='actionMenuButton' data-bs-toggle="dropdown" aria-expanded="false" className="btn">
                                                                <TapIcon.FontAwesomeIcon icon={TapIcon.faEllipsisV} />
                                                            </button>
                                                            <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                                                <li><a className="dropdown-item" role="button" onClick={() => this.viewActivity(item.asset_activity_id)}  >View</a></li>

                                                            </ul>
                                                        </td>
                                                    </Ax>
                                                    )}
                                        </tr>)
                                    }))
                                    : (<tr><td colSpan="10" className="text-center">No Records</td></tr>)
                                )
                            }

                        </tbody>

                    </table>

                </div>
                <div className='mx-3 my-1'>
                    <DisplayListPagination
                        meta={this.state.listingMeta}
                        onPageChange={(e) => this.getAssetActivityListing(e.selected + 1)}
                    />
                </div>

            </Ax>
        );
    }

    assetActivityViewDetailJsx                =   ()   =>   {
      
        return (<div>
            <div className="row mr0">
                <div className="col-sm-12 pr0 pb-4">
                {this.state.activityData ? <AssetActivityView activityData = {this.state.activityData} /> : null}
                </div>
                
                </div>
          
        </div>)
    }

    activitySearchModalJsx                             =   ()  =>  {
        return (
            <div className="modal fade" id="activitySearchModal" tabIndex="-1">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="activitySearchModalLabel">Activity Search</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <form onSubmit={this.activitySearchFormSubmit} id="activitySearchForm">
                            <div className="modal-body">
                                <div className="row mb-3">
                                    <label className="col-sm-2 col-form-label col-form-label-sm text-end">Transaction ID</label>
                                    <div className="col-sm-10">
                                        <input
                                            type="text"
                                            name="search_transaction_id"
                                            className="form-control form-control-sm"
                                            placeholder="Transaction ID"
                                            autoComplete="off"
                                            onChange={(e) => this.formInputHandler(e, "activitySearchForm")}
                                        />
                                    </div>

                                </div>
                                <div className='row mb-3'>
                                    <label className="col-sm-2 col-form-label col-form-label-sm text-end">Activity Name</label>
                                    <div className="col-sm-10">
                                        <TapSelect
                                            options={this.state.allActivitesList}
                                            changeEvent={(selectedOption) => this.tapSelectChange(selectedOption, 'activitySearchForm', 'search_activities')}
                                            isSearchable={true}
                                            isClearable={true}
                                            isMulti={true}
                                            value={this.state.allActivitesList.filter(s => this.state.activitySearchForm.search_activities.includes(s.value))}
                                            placeholder="Select Activity"
                                            containerHeight="30px"
                                            fontSize="93%"
                                        />
                                    </div>
                                </div>
                                <div className='row mb-3'>
                                    <label className="col-sm-2 col-form-label col-form-label-sm text-end">Activity type</label>
                                    <div className="col-sm-10">
                                        <TapSelect
                                            options={this.state.allActivityTypeList}
                                            changeEvent={(selectedOption) => this.tapSelectChange(selectedOption, 'activitySearchForm', 'search_activity_type')}
                                            isSearchable={true}
                                            isClearable={true}
                                            value={this.state.allActivityTypeList.find(s => this.state.activitySearchForm.search_activity_type == s.value)}
                                            placeholder="Select Activity Type"
                                            containerHeight="30px"
                                            fontSize="93%"
                                        />
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <label className="col-sm-2 col-form-label col-form-label-sm text-end">Site Group</label>
                                    <div className="col-sm-10">
                                        <TapSelect
                                            options={this.state.allSiteGroupsList}
                                            changeEvent={(selectedOption) => {

                                                this.setState({
                                                    activitySearchForm: {
                                                        ...this.state.activitySearchForm,
                                                        site_group_ids: selectedOption && selectedOption.length > 0 ? selectedOption.map(o => o.value) : [],
                                                        search_site_ids: selectedOption && selectedOption.length > 0 ? selectedOption.map(s => s.linked_sites).flat() : []
                                                    }
                                                })
                                            }}
                                            isSearchable={true}
                                            isClearable={true}
                                            isMulti={true}
                                            value={this.state.allSiteGroupsList.filter(s => this.state.activitySearchForm.site_group_ids.includes(s.value))}
                                            placeholder="Select Site Group"
                                            containerHeight="30px"
                                            fontSize="93%"
                                        />
                                    </div>

                                </div>
                                <div className='row mb-3'>
                                    <label className="col-sm-2 col-form-label col-form-label-sm text-end">Executed Site</label>
                                    <div className="col-sm-10">
                                        <TapSelect
                                            options={this.state.iam_group_sites}
                                            changeEvent={(selectedOption) => this.tapSelectChange(selectedOption, 'activitySearchForm', 'search_site_ids')}
                                            isSearchable={true}
                                            isClearable={true}
                                            isMulti={true}
                                            value={this.state.iam_group_sites.filter(s => this.state.activitySearchForm.search_site_ids.includes(s.value))}
                                            placeholder="Select Executed Site"
                                            containerHeight="30px"
                                            fontSize="93%"
                                        />
                                    </div>
                                </div>
                                <div className='row mb-3'>
                                    <label className="col-sm-2 col-form-label col-form-label-sm text-end">Transaction Delay</label>
                                    <div className="col-sm-10">
                                        <TapSelect
                                            options={this.state.allTransactionDelay}
                                            changeEvent={(selectedOption) => this.tapSelectChange(selectedOption, 'activitySearchForm', 'activity_transaction_delay')}
                                            isSearchable={true}
                                            isClearable={true}
                                            value={this.state.allTransactionDelay.find(s => this.state.activitySearchForm.activity_transaction_delay == s.value)}
                                            placeholder="Select Transaction Delay"
                                            containerHeight="30px"
                                            fontSize="93%"
                                        />
                                    </div>
                                </div>
                                <div className="row my-3 align-items-center">
                                    <label className="col-sm-2 col-form-label col-form-label-sm text-end ">Date of Entry</label>

                                    <div className="col-sm-10">
                                        <PeriodSelectionWithCustom
                                            periods={this.state.all_periods ? this.state.all_periods : []}
                                            value={this.state.activitySearchForm.entry_date_range}
                                            startDate={this.state.activitySearchForm.entry_date_range_start}
                                            endDate={this.state.activitySearchForm.entry_date_range_end}
                                            className="form-control-sm"
                                            containerHeight="30px"
                                            fontSize="93%"
                                            onSelectPeriod={(period, startDate, endDate) => {
                                                this.setState({
                                                    activitySearchForm
                                                        : {
                                                        ...this.state.activitySearchForm,
                                                        entry_date_range: period,
                                                        entry_date_range_start: startDate ? startDate : null,
                                                        entry_date_range_end: endDate ? endDate : null
                                                    }
                                                });
                                            }}
                                        />

                                    </div>

                                </div>

                                <div className="row my-3 align-items-center">
                                    <label className="col-sm-2 col-form-label col-form-label-sm text-end ">Transaction Period</label>

                                    <div className="col-sm-10">
                                        <PeriodSelectionWithCustom
                                            periods={this.state.all_periods ? this.state.all_periods : []}
                                            value={this.state.activitySearchForm.date_range}
                                            startDate={this.state.activitySearchForm.date_range_start}
                                            endDate={this.state.activitySearchForm.date_range_end}
                                            onSelectPeriod={(period, startDate, endDate) => {
                                                this.setState({
                                                    activitySearchForm
                                                        : {
                                                        ...this.state.activitySearchForm,
                                                        date_range: period,
                                                        date_range_start: startDate ? startDate : null,
                                                        date_range_end: endDate ? endDate : null
                                                    }
                                                });
                                            }}
                                            className="form-control-sm"
                                            containerHeight="30px"
                                            fontSize="93%"
                                        />

                                    </div>

                                </div>

                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                <button type="submit" className="btn btn-primary">Search</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    }

   
    render                      =   ()  =>  {
        return (<ApplicationLayout>
            <Helmet><title>Asset - Activity List</title></Helmet>
             {this.pageTitleBarJsx()}
            {this.horizontalAssetCardJsx()}
            {this.assetActivityListJsx()}
            {this.activitySearchModalJsx()}
        
        </ApplicationLayout>);
    }
    
}


const mapStateToProps = state => {
    return {
        access_token            :   state.auth.access_token,
        all_periods             :   state.app && state.app.all_periods ? state.app.all_periods : [],
        iam_group_sites         :   state.app && state.app.group_sites ? state.app.group_sites : [],
    };
};

export default connect(mapStateToProps, null, null, { forwardRef: true })(AssetActivity);